"use client"
import { useState, useRef, useEffect } from "react";
import DefaultButton from "../../components/DefaultButton";
import { BsArrowCounterclockwise } from "react-icons/bs";
import ghost from "../../assets/tris/ghost.png";
import x from "../../assets/tris/x.png";
import o from "../../assets/tris/o.png";
import styles from "./NotFound.module.css";

import bgMusic from "../../assets/tris/tetris_level_up.mp3";
import winSound from "../../assets/tris/goal.mp3";
import loseSound from "../../assets/tris/looser_tone.mp3";
import drawSound from "../../assets/tris/bomberman.mp3";
import placeXSound from "../../assets/tris/atari_frogger_win.mp3";
import placeOSound from "../../assets/tris/interface_text.mp3";

import { BsVolumeUpFill, BsVolumeMuteFill } from "react-icons/bs";


      
const WINNING_COMBINATIONS = [
  [0,1,2],
  [3,4,5],
  [6,7,8],
  [0,3,6],
  [1,4,7],
  [2,5,8],
  [0,4,8],
  [2,4,6]
];

export default function NotFound() {

    const [audioEnabled, setAudioEnabled] = useState(false);
    const bgAudioRef = useRef(null);
    const winAudioRef = useRef(null);
    const loseAudioRef = useRef(null);
    const drawAudioRef = useRef(null);
    const placeXAudioRef = useRef(null);
    const placeOAudioRef = useRef(null);


    const [board, setBoard] = useState(Array(9).fill(null));
    const [winner, setWinner] = useState(null);    
    const playerWon = winner === "X";
    const computerWon = winner === "O";
    const draw = winner === null && board.every(cell => cell !== null);
    const gameOver = playerWon || computerWon || draw;

    const [show404, setShow404] = useState(false);
    
    useEffect(() => {
        console.log("Noiosa questa 404 vero?", "Digita la password");
    }, []);

    const secretCode = "lapassword";
    const inputBuffer = useRef("");
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key.length !== 1) return;

            inputBuffer.current += e.key.toLowerCase();
            inputBuffer.current = inputBuffer.current.slice(-secretCode.length);
            if (inputBuffer.current === secretCode) {
                setShow404(true);
                inputBuffer.current = "";
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => {
        window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    

    useEffect(() => {
        const el = document.getElementById("hero-loader");
        if (el) {
            el.remove();
        }
    }, []);
        
    useEffect(() => {
        bgAudioRef.current = new Audio(bgMusic);
        bgAudioRef.current.loop = true;
        bgAudioRef.current.volume = 0.4;

        placeXAudioRef.current = new Audio(placeXSound);
        placeOAudioRef.current = new Audio(placeOSound);
        winAudioRef.current = new Audio(winSound);
        loseAudioRef.current = new Audio(loseSound);
        drawAudioRef.current = new Audio(drawSound);

        if (audioEnabled) {
            bgAudioRef.current
                .play()
                .then(() => {
                    setAudioEnabled(true);
                })
                .catch(() => {
                    console.log("Autoplay bloccato");

                    setAudioEnabled(false);
                });
        }

        return () => {
            bgAudioRef.current?.pause();
        };

        // if (audioEnabled) { 
        //     bgAudioRef.current.play().catch(() => { console.log("Autoplay bloccato"); }); 
        // }
    }, []);

    //effetto sonoro utente mette X
    function playShortEffect(effectRef) {
            if (!audioEnabled) return;

            effectRef.current.currentTime = 0;
            effectRef.current.play();
        }

    //abbassare musica durante effetti sonori
    function playEffect(effectRef) {
        if (!audioEnabled) return;

        const bg = bgAudioRef.current;

        if (bg) {
            bg.volume = 0.1;
        }

        effectRef.current.currentTime = 0;
        effectRef.current.play();

        effectRef.current.onended = () => {
            if (bg) {
                bg.volume = 0.4;
            }
        };
    }

    //toggle audio background
    function toggleAudio() {
        const newValue = !audioEnabled;

        setAudioEnabled(newValue);

        if (!bgAudioRef.current) return;

        if (newValue) {
            bgAudioRef.current.play();
        } else {
            bgAudioRef.current.pause();
        }
    }
              
    function getWinner(cells) {
        for (const [a,b,c] of WINNING_COMBINATIONS) {
            if (
                cells[a] &&
                cells[a] === cells[b] &&
                cells[a] === cells[c]
            ) {
                return cells[a];
            }
        }
        return null;
    }
      
    function handleClick(index) {
        if (board[index] || gameOver) return;

        const newBoard = [...board];
        newBoard[index] = "X";

        playShortEffect(placeXAudioRef);

        const win = getWinner(newBoard);

        setBoard(newBoard);

            // X vince    
            if (win) {
                setWinner("X");
                playEffect(winAudioRef);
                return;
            }
            // pareggio / nessun vincitore
            if (newBoard.every(cell => cell !== null)) {
                playEffect(drawAudioRef);
                return;
            }

        setTimeout(() => {
            computerMove(newBoard);
        }, 400);
    }
      
  function computerMove(currentBoard) {
      if (gameOver) return;

      const empty = currentBoard
          .map((c, i) => (c === null ? i : null))
          .filter(v => v !== null);

      if (!empty.length) return;

      const move = empty[Math.floor(Math.random() * empty.length)];

      const newBoard = [...currentBoard];
      newBoard[move] = "O";
      
    playShortEffect(placeOAudioRef);

      const win = getWinner(newBoard);

      setBoard(newBoard);

    //   if (win) {
    //       setWinner("O");
    //       return;
    //   }
    if (win) {
        setWinner("O");
        playEffect(loseAudioRef);
        return;
    }
    if (newBoard.every(cell => cell !== null)) {
        playEffect(drawAudioRef);
    }
  }

  function resetGame() {
      setBoard(Array(9).fill(null));
      setWinner(null);
  }


  

  return (
    <div className={styles.notfoundPage}>
        <h2 className={styles.title}>404</h2>
        <p className={styles.subtitle}>Pagina non trovata</p>

        {show404 && (
            <>
            <button
                onClick={toggleAudio}
                className={styles.audioBtn}
                aria-label={audioEnabled ? "Disattiva audio" : "Attiva audio"}>
                {audioEnabled ? <BsVolumeUpFill size={24}/> : <BsVolumeMuteFill size={24}/>}
            </button>

            <div className={styles.container}>
                {!playerWon && !computerWon && !draw && (
                    <p className={`${styles.message} ${styles.intro}`}>✨ Ma hai trovato un gioco! ✨</p>
                )}

                {playerWon && (
                    <div className={styles.bubble}>
                        <p className={styles.message}>
                        Hai vinto! 🎉<br/>
                        Te si sta brao.
                        </p>
                    </div>
                )}

                {computerWon && (
                    <div className={styles.bubble}>
                        <p className={styles.message}>
                        Hai perso! 😈<br/>
                        Che scarso
                        </p>
                    </div>
                )}

                {draw && (
                    <div className={`${styles.bubble} ${styles.bubbleNowinner}`}>
                        <p className={styles.message}>
                        Nessun vincitore 🙅‍♀️
                        </p>
                    </div>
                )}

                <div className={styles.boardWrapper}>
                    <img src={ghost} alt="mascotte" className={styles.ghost} />

                    <div className={styles.board}>
                        {board.map((cell,index) => (
                            <button
                                key={index}
                                className={styles.cell}
                                onClick={() => handleClick(index)}>
                                {cell === "X" && <img src={x} alt="X" className={styles.icon} />}
                                {cell === "O" && <img src={o} alt="O" className={styles.icon} />}
                            </button>
                        ))}
                    </div>
                </div>

                <div className={styles.footer}>
                    <button onClick={resetGame} 
                    className={styles.resetBtn}>
                        rigioca
                        <BsArrowCounterclockwise size={20} />
                    </button>

                    {playerWon && (
                        <DefaultButton text="Torna alla home" link="/" buttonClass="lg:w-full" />
                    )}
                </div>
            </div>
            </>
        )}
    </div>
  );
}